import { CacheUtility } from '../cache';
import { CommonUtility } from '../common';
import { APIPath } from '../constants';
import { BaseService } from './base';
import { CRUDService } from './crud.ts';

class Packaging extends CRUDService {
  constructor() {
    super(APIPath.ordersPackagingContainers);
  }

  clearPackingContainerDetailsCache() {
    CacheUtility.containsRemoved(APIPath.ordersPackagingContainerContents);
  }

  getPackingContainerDetails = async (params, forceRefresh = false) => {
    const url = `${
      APIPath.ordersPackagingContainerContents
    }/?${CommonUtility.objectToParams(params)}`;

    if (!forceRefresh) {
      const cached = CacheUtility.get(url);

      if (cached) {
        return cached;
      }
    }

    const res = await BaseService.get(url);
    CacheUtility.save(url, res, 0.2);

    return res;
  };

  packToteItem(id, body) {
    return BaseService.put(`${APIPath.ordersPackagingTote}/${id}/pack`, body).then(
      response => {
        this.clearPackingContainerDetailsCache();
        return response;
      },
    );
  }

  shipItem(id, body) {
    return BaseService.put(`${APIPath.orders}/${id}/allocations/ship`, body).then(
      response => {
        this.clearPackingContainerDetailsCache();
        return response;
      },
    );
  }

  getCompletedContainers(params) {
    const url = `${
      APIPath.ordersPackagingContainersCompleted
    }?${CommonUtility.objectToParams(params)}`;
    return BaseService.get(url);
  }

  printLabel(body) {
    return BaseService.post(APIPath.printLabel, body);
  }

  uploadScannerDiagnostics(body) {
    return BaseService.post(APIPath.scannerDiagnostics, body);
  }

  refundLabel(labelId) {
    return BaseService.post(`${APIPath.packagingLabel}/${labelId}/refund`).then(
      response => {
        this.clearPackingContainerDetailsCache();
        return response;
      },
    );
  }

  shippingRates(payload) {
    return BaseService.post(APIPath.packagingShippingRate, payload);
  }

  createLabel(payload) {
    return BaseService.post(APIPath.packagingShippingLabel, payload).then(response => {
      this.clearPackingContainerDetailsCache();
      return response;
    });
  }

  lableCorrection(payload) {
    return BaseService.post(APIPath.packagingLabelCorrection, payload).then(response => {
      this.clearPackingContainerDetailsCache();
      return response;
    });
  }
}

const PackagingService = new Packaging();
Object.freeze(PackagingService);
export { PackagingService };
